import { CreateOrderDialogType } from "../../createOrder/createOrderTypes"

export enum CreditNoteType {
    CREDIT = "CREDIT",
    DEBIT = "DEBIT",
}

export function mapCreditTypeToDialogType(type: CreditNoteType): CreateOrderDialogType | undefined {
    switch (type) {
        case CreditNoteType.CREDIT:
            return CreateOrderDialogType.CREDIT_NOTE
        case CreditNoteType.DEBIT:
            return CreateOrderDialogType.SUPPLEMENTARY_ORDER

        default:
            return undefined
    }
}
